import React from "react";
import "./ChartHeader.css";

// The scale mix is real: moments are 0-10, day scores 0-5, tasks sum to 50,
// wave reaches 15. Every figure on screen has to carry its denominator.
const denominatorFor = (config) => {
  if (!config || !config.yRange) return "";
  const [, max] = config.yRange;
  if (max === 1) return "%";
  return `/${max}`;
};

const formatAverage = (average, config) => {
  if (average === null || average === undefined || Number.isNaN(average)) {
    return "-";
  }
  // tasks_completion_rate is a 0-1 ratio that TimeSeries already scales to 100.
  return denominatorFor(config) === "%"
    ? `${average.toFixed(0)}%`
    : average.toFixed(1);
};

/**
 * `picker` is the mobile graph selector. When it is supplied it stands in for
 * the static title, on the same row as the average — the picker used to be its
 * own strip above this header, repeating the title it sat over.
 */
function ChartHeader({ title, config, family, average, picker }) {
  const isTimeSeries = family === "TimeSeries";
  const denominator = denominatorFor(config);
  const showAverage = isTimeSeries && average !== null && average !== undefined;

  const stat = showAverage ? (
    <div className="chart-header__stat">
      <span className="chart-header__stat-label">Average</span>
      <span className="chart-header__stat-value">
        {formatAverage(average, config)}
        {denominator !== "%" && (
          <span className="chart-header__stat-denominator"> {denominator}</span>
        )}
      </span>
    </div>
  ) : null;

  if (picker) {
    return (
      <div className="chart-header chart-header--picker">
        {picker}
        {stat}
      </div>
    );
  }

  return (
    <div className="chart-header">
      <div className="chart-header__main">
        <h2 className="chart-header__title">{title}</h2>
      </div>

      {stat}
    </div>
  );
}

export default ChartHeader;
